/* file description */
import { Modal, Button, Select, Menu, Checkbox, Radio, Space, Input, Segmented, Tag, Divider } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import React, { FC, useState } from 'react';
import { useGetTreeData, useGetDep } from './effect';

import { UserSelectProps } from './type';
import memo from '../memo';

const CheckboxGroup = Checkbox.Group;
const { Search } = Input;

export const DepUser: FC<UserSelectProps> = ({
  FetchAPI,
  field,
  value,
  onChange,
  form,
  config,
  columnFrom,
  isMulti,
  allowClear,
  disabled,
}) => {
  const [modalVisible, setVisible] = useState(false);
  const { depTreeData, changeTreeType, treeType } = useGetDep({ FetchAPI });
  const { treeData, checkBoxData, onSearch, clickMenu } = useGetTreeData({ field, FetchAPI, treeType });

  let tagList = [];
  if (isMulti) {
    tagList = field?.bizConfig?.userList.filter((item: any) => {
      const valueList = value || [];
      return valueList.includes(item.userAccount);
    });
  }

  const closeTag = (e: any, tag: any) => {
    e.preventDefault();
    const userIds = value.filter((item: any) => {
      return item !== tag.userAccount;
    });
    onChange?.(userIds);
  };

  return (
    <>
      <div style={{ display: 'flex', minWidth: '100px' }}>
        <Select
          style={{ width: '100%' }}
          showSearch
          showArrow={false}
          onChange={(val) => {
            onChange?.(val);
          }}
          mode={isMulti ? 'multiple' : undefined}
          value={value}
          options={treeData}
          optionFilterProp="userName"
          fieldNames={{
            label: 'userName',
            value: 'userAccount',
          }}
          allowClear={allowClear !== false}
          disabled={disabled}
        />
        <Button
          onClick={() => {
            setVisible(true);
          }}
          style={{ borderLeft: 'unset' }}
          icon={<SearchOutlined />}
          disabled={disabled}
        />
      </div>
      {modalVisible && (
        <Modal
          visible
          onCancel={() => setVisible(false)}
          width="750px"
          footer={null}
          title="选择人员"
          maskClosable={false}
        >
          <div style={{ display: 'flex', maxHeight: '600px' }}>
            <div style={{ width: '250px' }}>
              <Search placeholder="输入搜索" onSearch={onSearch} style={{ width: '100%' }} />
              <Segmented defaultValue="组织" options={['组织', '岗位']} onChange={changeTreeType} />
              <Menu
                style={{ overflowY: 'scroll', overflowX: 'hidden', height: '520px' }}
                items={depTreeData}
                mode="inline"
                onClick={clickMenu}
              />
            </div>
            <div style={{ paddingLeft: '30px', overflowY: 'scroll', flex: 1 }}>
              {
                isMulti ?
                  <div>
                    {
                      tagList.map((tag: any, index: number) => {
                        return <Tag key={index} style={{ marginBottom: '5px' }} closable onClose={(e) => { closeTag(e, tag); }}>{tag.userName}</Tag>;
                      })
                    }
                    <Divider style={{ margin: '8px 0' }} />
                    <CheckboxGroup
                      onChange={(val) => {
                        onChange?.(val);
                      }}
                      value={value}
                      style={{ display: 'flex', flexDirection: 'column' }}
                      options={checkBoxData}
                    />
                  </div> :
                  <Radio.Group
                    onChange={(val) => {
                      onChange?.(val);
                    }}
                    value={value}
                  >
                    <Space direction="vertical">
                      {
                        checkBoxData.map((radio: any, index: number) => {
                          return <Radio key={index} value={radio.value}>{radio.label}</Radio>;
                        })
                      }
                    </Space>
                  </Radio.Group>
              }
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};
export default memo(DepUser);
